// Import the functions you need from the SDKs you need
import { type FirebaseOptions, initializeApp } from 'firebase/app'
import { getAnalytics, setAnalyticsCollectionEnabled } from 'firebase/analytics'
// TODO: Add SDKs for Firebase products that you want to use
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
/* import { connectFunctionsEmulator, getFunctions } from "firebase/functions"; */
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
function config(): FirebaseOptions {
  const sharedConfig: FirebaseOptions = {
    apiKey: 'AIzaSyBrIabKw3IoLxHKEdFHvoQUzyMupK43d_U',
    authDomain: 'fundaysheffield.com',
    projectId: 'crunchy-kids',
    storageBucket: 'crunchy-kids.appspot.com',
    messagingSenderId: '82517584258',
    appId: '1:82517584258:web:7f0d47cbb243025ed4479b'
  }

  /*  if (process.client && window.location.origin.includes("localhost")) {
     return sharedConfig;
   } */

  return {
    ...sharedConfig,
    measurementId: 'G-KFEHD46KWH'
  }
}

// Initialize Firebase
const app = initializeApp(config())
const auth = getAuth(app)
const analytics = getAnalytics(app)

const db = getFirestore(app)
if (window.location.origin.includes('locaaalhost')) {
  connectFirestoreEmulator(db, 'localhost', 8081)
  setAnalyticsCollectionEnabled(analytics, false)
}
export { db, auth, analytics }

import { where, type WhereFilterOp } from 'firebase/firestore'

export function typedWhere<T>(fieldPath: Extract<keyof T, string>, opStr: WhereFilterOp, value: unknown) {
  return where(fieldPath, opStr, value)
}
